<template lang='pug'>
  table-list(:headers='headers' :items='agents' :total='agents.length' :table-only='true' :loading='loading' :select-all='false' :has-selection='false' @update='update')
    template(v-slot:row='{item}')
      td {{item.guid}}
      td
        v-icon(small v-if='item.isRunning') check
      td {{item.currentTestRunGuid}}
      td {{item.currentTestIndex}}
      td
        v-tooltip(right)
          template(v-slot:activator='{on}')
            span(v-on='on') {{item.stateLastUpdated | date}}
          span {{item.stateLastUpdated | timeago}}
      td {{item.osPlatform}}
      td {{item.versionString}}
      td {{item.commitHash}}
      td
        v-icon(v-if='item.heavy') check
      td
        v-tooltip(right)
          template(v-slot:activator='{on}')
            span(v-on='on') {{item.lastSeenRunning | timeago }}
          span {{item.lastSeenRunning | date}}
      td
        v-tooltip(right)
          template(v-slot:activator='{on}')
            span(v-on='on') {{item.lastSeenAt | timeago}}
          span {{item.lastSeenAt | date}}
      td
        v-tooltip(right)
          template(v-slot:activator='{on}')
            span(v-on='on') {{item.createdAt | timeago }}
          span {{item.createdAt | date}}
</template>

<script>
import _ from 'lodash';
import SuperAdmin from '../../../api/superAdmin';
import Messages from '../../../services/message.service';
import TableList from '../../../components/TableList';

export default {
  name: 'SuperAdminAgents',
  components: {TableList},
  async mounted() {
    await this.update();
    this.messageListener = {message: this.onMessage};
    this.agentGuids = _.map(this.agents, 'guid');
    await Messages.subscribe(this.agentGuids, this.messageListener, this.messageKey);
  },
  async beforeDestroy() {
    await Messages.unsubscribe(this.agentGuids, this.messageListener, this.messageKey);
  },
  methods: {
    async update() {
      this.loading = true;
      this.agents = (await SuperAdmin.getAgents()).list;
      this.loading = false;
    },
    onMessage(data) {
      if (!data || !data.message || !data.message.guid) return;
      for (let i = 0; i < this.agents.length; ++i) {
        if (this.agents[i].guid === data.message.guid) {
          // https://vuejs.org/2016/02/06/common-gotchas/
          this.agents.splice(i, 1, data.message);
          return;
        }
      }
    },
    to(route) {
      this.$router.push(route);
    }
  },
  data() {
    return {
      agents: [],
      agentGuids: [],
      total: null,
      loading: false,
      messageListener: null,
      messageKey: 'agents',
      headers: [
        {text: 'Agent Guid', value: 'guid'},
        {text: 'Running', value: 'isRunning'},
        {text: 'Current Test Run', value: 'currentTestRunGuid'},
        {text: 'Current Test Index', value: 'currentTestIndex'},
        {text: 'State Last Updated', value: 'stateLastUpdated'},
        {text: 'OS', value: 'osPlatform'},
        {text: 'Version', value: 'versionString'},
        {text: 'Commit', value: 'commitHash'},
        {text: 'Heavy', value: 'heavy'},
        {text: 'Last Seen Running', value: 'lastSeenRunning'},
        {text: 'Seen', value: 'lastSeenAt'},
        {text: 'Created', value: 'createdAt'}
      ]
    };
  }
};
</script>

<style scoped>

</style>
